import React, { FC, useState } from "react";

import { useLabels } from "../Hooks/useLabels";

import { FourthStepInfoContainer } from "../FormElements";
import { CancellationMessage } from "../CancellationMessage/CancellationMessage";

import { DoctorDto } from "@apiModels/DoctorDto.csharp";
import { WaitlistViewModel } from "../../../Blocks/Waitlist/WaitlistViewModel.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";
import { AppointmentDto } from "@apiModels/AppointmentDto.csharp";
import { ServiceContainerDto } from "@apiModels/ServiceContainerDto.csharp";
import { PricingSummaryModal } from "../FormElements/Modal/PricingSummaryModal/PricingSummaryModal";
import { calculateTotalPrice } from "../Helpers/totalPriceCalculator";
import { PriceDetailsButton } from "../PriceDetailsButton/PriceDetailsButton";
import { ServicePricingSummary } from "../../../Partials/PricingHighlight/ServicePricingSummary.csharp";
import {SummaryPart} from "../Summary/SummaryPart";
import {
    CAMPAIGN_PRICE,
    CENTER_NAME,
    DATE_AND_TIME,
    DOCTOR_NAME, PRICE,
    SERVICE_NAME,
    SPECIALIZATION_NAME
} from "../Summary/labels";
import {displayPrice, formatDate} from "../Summary/helpers";

type FormAppointmentDetailsProps = {
  appointment: AppointmentDto;
  service: ServiceContainerDto;
  specializationName: string;
  doctor?: DoctorDto;
  center: LocationDto;
  displayHeading?: boolean;
  waitlist?: WaitlistViewModel;
  pricingSummary: ServicePricingSummary;
  cancellationMessage: string;
};

export const FormAppointmentDetails: FC<FormAppointmentDetailsProps> = ({
    appointment,
    service,
    specializationName,
    doctor,
    center,
    displayHeading = true,
    waitlist,
    pricingSummary,
    cancellationMessage,
  }) => {
  const { bookingLabels } = useLabels();
  const fourthStepLabels = bookingLabels?.stepsBookingLabels.fourthStepLabels;
  const appointmentStartTime = new Date(appointment.startTime);
  const [showPricingSummaryModal, setShowPricingSummaryModal] = useState(false);
  const isWaitlist = !!waitlist?.contentId;
  const showPricingSummary = !!pricingSummary && !!pricingSummary.variantId;
  const showPriceDetailsButton = service.disablePriceDetails == false;

  const totalPrice = showPricingSummary
      ? calculateTotalPrice(pricingSummary)
      : "";

  return (
    <FourthStepInfoContainer>
      <div className="FormAppointmentDetails">
        {displayHeading && (
          <h2>
            {isWaitlist
                ? "Registrert!"
                : fourthStepLabels?.appointmentDetailsHeading}
          </h2>
        )}
        <dl className="FormAppointmentDetails__list">
          {!!specializationName && 
          <SummaryPart
            label={SPECIALIZATION_NAME}
            content={specializationName}
          />
          }
          <SummaryPart
            label={SERVICE_NAME}
            content={waitlist
              ? waitlist.serviceName
              : service.summaryName ?? service.name}
          />
            
          {!waitlist && !!doctor && !doctor.isNotADoctor && (
            <SummaryPart
              showJobTitle={service.showDoctorsJobTitle}
              label={DOCTOR_NAME}
              content={<a href={doctor?.doctorUrl} className="FormAppointmentDetails__bareLink">
                  <span>{doctor?.name ?? ""}</span>
              </a>}
              additionalContent={doctor.jobTitle ?? ""}
            />
          )}

          {!waitlist &&
            <SummaryPart
              label={DATE_AND_TIME}
              content={formatDate(appointmentStartTime)}
            />
          }

          {center && <SummaryPart
            label={CENTER_NAME}
            content={center.name}
          />}

          {!waitlist && (
            <>
              {showPricingSummary && (
                <SummaryPart
                  label={
                    !!pricingSummary.campaignPrice
                      ? CAMPAIGN_PRICE
                      : PRICE
                  }
                >
                  {!pricingSummary.listWithoutPrice && (
                    <div className={"Summary__price"}>
                      {displayPrice(totalPrice)}
                    </div>
                  )}
                  {showPriceDetailsButton && (
                    <PriceDetailsButton
                      service={service}
                      bookingLabels={bookingLabels!}
                      onClick={() => setShowPricingSummaryModal(true)}
                    />
                      
                  )}
                </SummaryPart>
              )}
                

              {/*DISABLED FOR LAUNCH*/}
              {/*<div className="mb-1">*/}
                {/*<AddToCalendar*/}
                {/*  service={service}*/}
                {/*  startTime={appointmentStartTime}*/}
                {/*  endTime={appointmentEndTime}*/}
                {/*  location={center}*/}
                {/*/>*/}
              {/*</div>*/}
            </>
          )}
        </dl>

        <CancellationMessage message={cancellationMessage} />
          
        {showPricingSummary && (
          <PricingSummaryModal
            onClose={() => setShowPricingSummaryModal(false)}
            isOpen={showPricingSummaryModal}
            pricingSummary={pricingSummary}
          />
        )}
      </div>
    </FourthStepInfoContainer>
  );
};
